import {
    getPredefinedGroupLabel,
    groupAccountTypesByClass,
} from "@common/constants/domains/accounting/accountGroups";
import { AccountType } from "@common/constants/domains/accounting/accounts";
import type { PickerItemData } from "@design-system/Picker/Picker.types";

export const CLASS_NODE_PREFIX = "class:";

// Use exact labels so soft-retired types remain distinct from their report leaves.
// Class rows are tree parents, which a single-select Picker never selects.
export const buildAccountTypeTree = (
    types: readonly AccountType[],
): Array<PickerItemData<string>> =>
    groupAccountTypesByClass(types).map(
        ({ accountClass, types: classTypes }): PickerItemData<string> => ({
            value: `${CLASS_NODE_PREFIX}${accountClass}`,
            label: accountClass,
            children: classTypes.map((type) => ({
                value: type,
                label: getPredefinedGroupLabel(type),
            })),
        }),
    );
